/* RuleIndexComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./RuleIndexRenderer");

class RuleIndexComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setRuleIndex(newVal);
        }
    }
    setRuleIndex(newVal) {
        this._value = newVal;
        this.emit("RuleIndex", newVal);
    }

    getValue() {
        return this.getRuleIndex();
    }
    getRuleIndex() {
        return this._value;
    }
    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
}

module.exports = RuleIndexComponent;
